document.addEventListener('DOMContentLoaded', function () {
  if (!('IntersectionObserver' in window)) return;

  var skipSelectors = ['header', '[class*="section-header-group"]', '[class*="section-announcement-bar"]'];

  var sections = document.querySelectorAll('main .shopify-section');
  var toObserve = [];

  sections.forEach(function (el) {
    var skip = skipSelectors.some(function (sel) {
      return el.matches(sel) || el.closest(sel);
    });
    if (skip) return;
    el.classList.add('hasheen-fade-init');
    toObserve.push(el);
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hasheen-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  toObserve.forEach(function (el) {
    observer.observe(el);
  });
});

/* ===================================================================
   Hasheen — Free Atta promo popup
   Shows INSTANTLY (no delay) on every fresh page load, but only once
   per browser session — the session flag is set the moment the popup
   is shown (not on close), so it cannot re-trigger on the same tab
   even if the user clicks the CTA link and lands back on the site.
   =================================================================== */
(function () {
  var STORAGE_KEY = 'hasheenFreeAttaPopupShown';

  function showPopup() {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    sessionStorage.setItem(STORAGE_KEY, '1');

    var overlay = document.createElement('div');
    overlay.className = 'hasheen-promo-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Free Hasheen Multigrain Atta offer');

    overlay.innerHTML =
      '<div class="hasheen-promo-modal">' +
        '<button type="button" class="hasheen-promo-close" aria-label="Close">&times;</button>' +
        '<p class="hasheen-promo-eyebrow">LIMITED TIME OFFER</p>' +
        '<h2 class="hasheen-promo-heading">Get Hasheen Multigrain Atta <span>FREE</span></h2>' +
        '<p class="hasheen-promo-text">Pick it up in person for free, or get it delivered for just &pound;2.49. Limited to one per customer.</p>' +
        '<a class="button button--primary hasheen-promo-cta" href="/discount/FREEATTA?redirect=/products/hasheen-high-fibre-multigrain-atta">Make It Yours Now</a>' +
        '<button type="button" class="hasheen-promo-dismiss">No thanks</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.classList.add('hasheen-promo-open');

    requestAnimationFrame(function () {
      overlay.classList.add('hasheen-promo-visible');
    });

    function closePopup() {
      overlay.classList.remove('hasheen-promo-visible');
      document.body.classList.remove('hasheen-promo-open');
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 350);
    }

    overlay.querySelector('.hasheen-promo-close').addEventListener('click', closePopup);
    overlay.querySelector('.hasheen-promo-dismiss').addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', escHandler);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showPopup);
  } else {
    showPopup();
  }
})();

/* ===================================================================
   Hasheen — limit Multigrain Atta to 1 unit per order.
   Matches the real theme markup on this store:
     - Product page / homepage buy box: <input class="quantity__input"
       name="quantity"> inside a <form data-type="add-to-cart-form">
       whose hidden <input name="id"> holds the variant ID.
     - Cart page + cart drawer: <input class="quantity__input"
       data-quantity-variant-id="VARIANT_ID">
   Client-side only (Shopify's per-order quantity-rule API is a
   Plus/B2B-only feature not available on this plan), reinforced by
   the FREEATTA discount code's one-redemption-per-customer limit,
   which is enforced server-side at checkout.
   =================================================================== */
(function () {
  var ATTA_VARIANT_ID = '62350866973059';
  var MAX_QTY = 1;

  function disablePlus(input) {
    var wrapper = input.closest('quantity-input, .quantity');
    if (!wrapper) return;
    var plus = wrapper.querySelector('[name="plus"]');
    if (plus) {
      plus.disabled = true;
      plus.style.opacity = '0.4';
      plus.style.pointerEvents = 'none';
      plus.style.cursor = 'not-allowed';
    }
  }

  function enablePlus(input) {
    var wrapper = input.closest('quantity-input, .quantity');
    if (!wrapper) return;
    var plus = wrapper.querySelector('[name="plus"]');
    if (plus) {
      plus.disabled = false;
      plus.style.opacity = '';
      plus.style.pointerEvents = '';
      plus.style.cursor = '';
    }
  }

  function clamp(input) {
    input.setAttribute('max', MAX_QTY);
    var val = parseInt(input.value, 10);
    if (!val || val > MAX_QTY) {
      input.value = MAX_QTY;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (parseInt(input.value, 10) >= MAX_QTY) {
      disablePlus(input);
    } else {
      enablePlus(input);
    }
  }

  function watch(input) {
    if (input.dataset.hasheenAttaClamped) {
      clamp(input);
      return;
    }
    input.dataset.hasheenAttaClamped = 'true';
    clamp(input);
    ['input', 'change'].forEach(function (evt) {
      input.addEventListener(evt, function () {
        clamp(input);
      });
    });
  }

  function isAttaBuyBoxInput(input) {
    if (input.name !== 'quantity') return false;
    var form = input.closest('form');
    if (!form) return false;
    var idField = form.querySelector('input[name="id"]');
    return !!idField && idField.value === ATTA_VARIANT_ID;
  }

  function isAttaCartInput(input) {
    return input.getAttribute('data-quantity-variant-id') === ATTA_VARIANT_ID;
  }

  function sweep(root) {
    root.querySelectorAll('input.quantity__input, input[data-quantity-variant-id]').forEach(function (input) {
      if (isAttaBuyBoxInput(input) || isAttaCartInput(input)) {
        watch(input);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    sweep(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) sweep(document);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
